/* eslint-disable no-shadow,no-param-reassign,no-mixed-operators */
import axios from 'axios';

const state = {
  endpoint: 'api/public-documents',
  selectedFiles: [],
  registrationId: '',
};

const getters = {};

const mutations = {
  setFiles(state, files) {
    state.selectedFiles = files;
  },
};

const actions = {
  async upload({ state }) {
    const uploadPromises = [];
    try {
      Array.from(state.selectedFiles).forEach((file) => {
        const requestBody = new FormData();
        requestBody.append('document', file);
        requestBody.append('client_id', state.registrationId);
        requestBody.append('type', 'contract');
        uploadPromises.push(
          axios.post(`${state.endpoint}`, requestBody, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }),
        );
      });
      const res = await axios.all(uploadPromises);
      return res;
    } catch (e) {
      throw e;
    }
  },

  uploadWarrant({ state }, clientID) {
    const requestBody = new FormData();
    requestBody.append('document', state.selectedFiles[0]);
    requestBody.append('client_id', clientID);
    requestBody.append('type', 'other');
    return new Promise((resolve, reject) => {
      axios.post(`${state.endpoint}`, requestBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },

  getSigningTokens(context, document) {
    return new Promise((resolve, reject) => {
      axios.post(`api/documents/prepare-to-sign/${document.id}/${document.hash}`)
        .then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        });
    });
  },

  checkSignature(context, document) {
    return new Promise((resolve, reject) => {
      axios.get(`api/check-isign-status/${document.id}`)
        .then((res) => {
          resolve(res);
        }).catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
